import { useTranslation } from 'react-i18next';
import MeetingForm from '../MeetingForm/MeetingForm';
import { Modal } from '../Modal/Modal';
import { Meeting } from '../../api/MeetingsAPI';
import MeetingsAPI from '../../api/MeetingsAPI';
import { toastService } from '../../services/ToastService';

type Props = {
  meeting: Meeting | null;
  onMeetingChange?: (value: Meeting) => void;
  isDisabled?: boolean;
  actionButton?: JSX.Element;
  timeZone?: string;
  modalTitle?: string;
  onClose?: () => void;
};

// Remove ViewMode type since we'll use a simple boolean for modal state

function MeetingFormWrapper({ 
  meeting, 
  onMeetingChange = () => null, 
  isDisabled = false, 
  actionButton, 
  timeZone,
  modalTitle,
  onClose
}: Props) {
  const { t } = useTranslation();

  const handlePaymentStatusChange = async (id: number, paid: boolean) => {
    try {
      await MeetingsAPI.updatePaymentStatus(id, paid);
    } catch (error) {
      console.error('Error updating payment status:', error);
      toastService.showToast(t("booking.pending.payment_update_error") || "Failed to update payment status", "error");
    }
  };

  return (
    <Modal modalTitle={modalTitle || t("calendar.meeting.form")} canClose onClose={onClose}>
      <MeetingForm
        meeting={meeting}
        onMeetingChange={onMeetingChange}
        isDisabled={isDisabled}
        actionButton={actionButton}
        timeZone={timeZone}
        onPaymentStatusChange={handlePaymentStatusChange}
      />
    </Modal>
  );
}

export default MeetingFormWrapper;
